<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="title"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import {createNamespacedHelpers} from "vuex";


  const {mapState, mapActions} = createNamespacedHelpers('setup/dependedField');

  export default {
    name: "DependedFieldSearch",
    components: {InputWidget},
    computed: {
      ...mapState({
        searchModel: state => state.dependedFields.searchModel,
      })
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions(['loadDependedFields', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.loadDependedFields();
      },
      onResetClick() {
        this.resetTable();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
